/**
 * Slack Integration Enums
 *
 * Enums used across the Slack integration entities
 */

/**
 * Setup Status Enum
 * Tracks the progress of the Slack integration wizard setup
 */
export enum SlackSetupStatus {
  CONNECTED = "CONNECTED",
  OWNERS_CONFIGURED = "OWNERS_CONFIGURED",
  CHANNELS_MAPPED = "CHANNELS_MAPPED",
  NOTIFICATIONS_CONFIGURED = "NOTIFICATIONS_CONFIGURED",
  COMPLETED = "COMPLETED",
}

/**
 * Notification Type Enum
 * Types of notifications that can be sent to Slack
 */
export enum SlackNotificationType {
  WEEKLY_SUMMARY = "WEEKLY_SUMMARY",
  NO_ACTIVITY_ALERT = "NO_ACTIVITY_ALERT",
  PRODUCT_FEEDBACK = "PRODUCT_FEEDBACK",
}

/**
 * Alert Status Enum
 * Status of Slack alert delivery
 */
export enum SlackAlertStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}
